// extracted by mini-css-extract-plugin
export default {"switcher_container":"index_switcher_container__9qgL3","switcher_container1":"index_switcher_container1__GLVwu"};